import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import historyData from '../../../data/history.json';
import YearBox from '../../molecules/YearBox/YearBox';

export default function HistoryBox() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.hBox}>
        <Box className={classes.line} />
        {historyData.map((h, i) => {
          if (i === 0)
            return (
              <Box key={i} className={classes.firstHistory}>
                <Box className={classes.firstYear}>{h.year}</Box>
                <Box className={classes.firstText}>{h.text}</Box>
              </Box>
            );
          return (
            <Box key={i} className={classes.yearOuter}>
              <YearBox year={h.year} text={h.text} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  hBox: {
    position: 'relative',
    width: '100%',
  },
  line: {
    width: '1px',
    height: '100%',
    borderLeft: `1px solid ${theme.color.black}`,
    position: 'absolute',
    left: '35px',
    zIndex: '-1',
  },
  firstHistory: {
    display: 'flex',
    marginBottom: '20px',
    fontSize: '16px',
    '@media only screen and (max-width:1024px)': {
      fontSize: '22px',
    },
    '@media only screen and (max-width:768px)': {
      fontSize: '12px',
    },
  },
  firstYear: {
    backgroundColor: theme.color.black,
    color: theme.color.white,
    minWidth: '72px',
    maxWidth: '72px',
    height: '40px',
    margin: '0 16px 0 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    fontSize: '16px',
    '@media only screen and (max-width:1024px)': {
      fontSize: '22px',
    },
    '@media only screen and (max-width:768px)': {
      fontSize: '14px',
    },
  },
  firstText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  yearOuter: {
    marginLeft: '24px',
  },
}));
